if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


(() => {
  if (window.__workmateOrderLimitSyncInstalled) return;
  window.__workmateOrderLimitSyncInstalled = true;

  const getMinimum = (productInfo) => {
    const content = productInfo?.querySelector('.samita-orderlimit-alert-content');
    const alert = content?.closest('.samita-orderlimit-alert');
    if (!content || !alert || getComputedStyle(alert).display === 'none') return null;

    const match = content.textContent.match(/at least\s+(\d+)\s+products/i);
    return match ? parseInt(match[1], 10) : null;
  };

  const syncMinimum = (productInfo) => {
    if (!productInfo) return;

    const input = productInfo.querySelector('input[name="quantity"]');
    const minusButton = productInfo.querySelector('quantity-input button[name="minus"]');
    if (!input) return;

    const minimum = getMinimum(productInfo);
    if (!minimum) {
      if (!input.dataset.workmateOrderLimit) return;

      const nativeMinimum = parseInt(input.dataset.workmateNativeMin, 10) || 1;
      input.min = nativeMinimum;
      input.dataset.min = nativeMinimum;
      delete input.dataset.workmateOrderLimit;
      delete input.dataset.workmateNativeMin;

      if (minusButton) {
        const isAtNativeMinimum = (parseInt(input.value, 10) || 0) <= nativeMinimum;
        minusButton.disabled = isAtNativeMinimum;
        minusButton.classList.toggle('disabled', isAtNativeMinimum);
      }
      return;
    }

    if (!input.dataset.workmateNativeMin) {
      input.dataset.workmateNativeMin = input.dataset.min || input.min || '1';
    }

    input.dataset.workmateOrderLimit = minimum;
    input.min = minimum;
    input.dataset.min = minimum;

    if ((parseInt(input.value, 10) || 0) < minimum) {
      input.value = minimum;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (minusButton) {
      const isAtMinimum = (parseInt(input.value, 10) || 0) <= minimum;
      minusButton.disabled = isAtMinimum;
      minusButton.classList.toggle('disabled', isAtMinimum);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const minusButton = event.target.closest('quantity-input button[name="minus"]');
      if (!minusButton) return;

      const productInfo = minusButton.closest('product-info');
      const input = productInfo?.querySelector('input[name="quantity"]');
      const minimum = getMinimum(productInfo);
      if (!input || !minimum || (parseInt(input.value, 10) || 0) > minimum) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      syncMinimum(productInfo);
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const productInfo = event.target.closest('product-info');
      if (productInfo) queueMicrotask(() => syncMinimum(productInfo));
    },
    true
  );

  const syncAll = () => document.querySelectorAll('product-info').forEach(syncMinimum);
  document.addEventListener('DOMContentLoaded', syncAll);
  setInterval(syncAll, 250);
})();
